import React, {Component} from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import DataTable from "react-data-table-component";
import {Link} from "react-router-dom";

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top'
        },
        title: {
            display: true,
            text: 'Break Even Costs Chart',
        },
    },
};

let labels = [];

const columns = [
    {
        name: 'Type',
        selector: 'type',
        sortable: true,
        grow: 2
    }
];


for (let i = 2020; i <= 2050; i++) {
    columns.push({
        name: '' + i,
        selector: '' + i,
        sortable: true
    });
}

for (let i = 2020; i <= 2050; i++) {
    labels.push(i);
}

class CalculatorResult extends Component {

    state = {
        results: this.props.results,
        breakEvenCosts: [],
        totalSUCResults: []
    };

    componentDidMount() {
        this.init()
    }


    back = () => {
        debugger;
        window.location.href = '/pst';
        //this.props.history.push('/pst');
    }

    init() {
        let totalSUCResults = this.state.results['totalSUCResult'];
        totalSUCResults.type = 'Result of SUC - Total';
        this.setState({totalSUCResults: [totalSUCResults]});

        let yearlyResults = this.state.results['yearlyResultMap'];
        yearlyResults.type = 'Yearly result';

        let breakEvenAnalysis = this.state.results['breakEvenAnalysisMap'];
        breakEvenAnalysis.type = 'Break even analysis';

        let breakEvenAnalysisData = [yearlyResults, breakEvenAnalysis];

        this.setState({breakEvenCosts: breakEvenAnalysisData});


        this.setState({
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Yearly result',
                        data: Object.values(this.state.results['yearlyResultMap']),
                        backgroundColor: 'rgb(15,32,138)'
                    },
                    {
                        label: 'Break even analysis',
                        data: Object.values(this.state.results['breakEvenAnalysisMap']),
                        backgroundColor: 'rgb(253,55,78)',
                    },
                ],
            }
        });
    }

    render() {
        return (
            <Container>
                <div className="row py-2">
                    <Link to={{
                        pathname: '/pst'
                    }} >
                        <Button variant="outline-primary">Back</Button>
                    </Link>
                </div>
                <div className="row result-header">
                    <h3>Results</h3>
                </div>

                <div className="row mb-5">
                    <Col xs={12}>
                        <span className="font-weight-bold">Result (nominal):</span><span> {this.state.results['nominalResult']}</span>
                    </Col>
                    <Col xs={12}>
                        <span className="font-weight-bold">Result as net present value (NPV):</span><span> {this.state.results['netPresentValueResult']}</span>
                    </Col>
                    <Col xs={12}>
                        <span className="font-weight-bold">Result per invested euro in NPV:</span><span> {this.state.results['perInvestedEuroResult']}</span>
                    </Col>
                </div>


                <div className="row">
                    <Bar data={this.state.data} options={options}/>
                </div>

                <div className="row policy-result">
                    <h5>Net Present Value</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={this.state.totalSUCResults}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="row policy-result">
                    <h5>Break Even Costs</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={this.state.breakEvenCosts}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>

            </Container>

        )
    }
}

export default CalculatorResult;
